<template>
  <nav
    :class="'navbar ' + navbarTheme"
    role="navigation"
    aria-label="main navigation">
    <div class="navbar-brand">
      <router-link
        to="/"
        class="navbar-item">Apollo</router-link>
    </div>
    <div
      v-if="fullName !== ''"
      class="navbar-menu">
      <div class="navbar-start">
        <router-link
          to="/scan"
          class="navbar-item">
          <b-icon
            size="is-small"
            icon="barcode-scan" />
          <span class="navbar-link-text">Scan</span>
        </router-link>
        <router-link
          to="/articles"
          class="navbar-item">
          <b-icon
            size="is-small"
            icon="tag-text-outline" />
          <span class="navbar-link-text">Articles</span>
        </router-link>
        <router-link
          to="/factories"
          class="navbar-item">
          <b-icon
            size="is-small"
            icon="domain" />
          <span class="navbar-link-text">Factories</span>
        </router-link>
        <router-link
          to="/reports"
          class="navbar-item">
          <b-icon
            size="is-small"
            icon="chart-areaspline" />
          <span class="navbar-link-text">Reports</span>
        </router-link>
        <router-link
          to="/pdf"
          class="navbar-item">
          <b-icon
            size="is-small"
            icon="file-pdf-box" />
          <span class="navbar-link-text">PDF</span>
        </router-link>
      </div>

      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            {{ fullName }}
          </a>

          <div class="navbar-dropdown is-right">
            <!-- <hr class="navbar-divider"> -->
            <a
              class="navbar-item"
              @click="logout">
              Log Out
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { logout } from '../utils/auth'

export default {
  name: 'app-nav',
  props: {
    'full-name': {
      type: String,
      default: ''
    },
    'navbarTheme': {
      type: String,
      default: 'is-dark'
    }
  },
  methods: {
    logout: function() {
      logout()
      this.$router.push('/login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
nav {
  margin-bottom: 20px;
}
.navbar-link-text {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppNav.vue